// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Density overrides — toggled via data-density on <html> by ThemeProvider.
   "comfortable" (default) keeps the spacious shell values; "compact" tightens
   the shell chrome (sidebar, top bar, content padding) so more fits on screen.
   See docs/frontend/DESIGN_REDESIGN.md §6.2.
   Page-specific tab strips (Collection, Mini Games, Divination) are left alone. */

html[data-density='compact'] .app-topbar {
  padding: var(--space-xs) var(--space-md);
}

html[data-density='compact'] .app-content {
  padding: var(--space-md);
}

html[data-density='compact'] .app-sidebar {
  width: 198px;
  padding: var(--space-xs);
  gap: 2px;
}

html[data-density='compact'] .app-sidebar.app-sidebar-collapsed {
  width: 56px;
}

html[data-density='compact'] .sb-brand {
  padding: 2px var(--space-sm);
  margin-bottom: 0;
}

html[data-density='compact'] .sb-collapse-btn {
  width: 30px;
  height: 30px;
}

html[data-density='compact'] .sb-item,
html[data-density='compact'] .sb-staff-toggle {
  padding: 6px var(--space-sm);
  font-size: var(--font-size-sm);
}

html[data-density='compact'] .sb-icon {
  font-size: var(--font-size-base);
}

html[data-density='compact'] .sb-staff {
  margin-top: var(--space-xs);
  padding-top: var(--space-xs);
}

/* On large screens, comfortable mode can breathe a bit more. */
html[data-density='comfortable'] .app-content {
  padding: var(--space-lg) var(--space-xl);
}
`, "",{"version":3,"sources":["webpack://./src/styles/density.css"],"names":[],"mappings":"AAAA;;;;kFAIkF;;AAElF;EACE,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,+DAA+D;AAC/D;EACE,wCAAwC;AAC1C","sourcesContent":["/* Density overrides — toggled via data-density on <html> by ThemeProvider.\n   \"comfortable\" (default) keeps the spacious shell values; \"compact\" tightens\n   the shell chrome (sidebar, top bar, content padding) so more fits on screen.\n   See docs/frontend/DESIGN_REDESIGN.md §6.2.\n   Page-specific tab strips (Collection, Mini Games, Divination) are left alone. */\n\nhtml[data-density='compact'] .app-topbar {\n  padding: var(--space-xs) var(--space-md);\n}\n\nhtml[data-density='compact'] .app-content {\n  padding: var(--space-md);\n}\n\nhtml[data-density='compact'] .app-sidebar {\n  width: 198px;\n  padding: var(--space-xs);\n  gap: 2px;\n}\n\nhtml[data-density='compact'] .app-sidebar.app-sidebar-collapsed {\n  width: 56px;\n}\n\nhtml[data-density='compact'] .sb-brand {\n  padding: 2px var(--space-sm);\n  margin-bottom: 0;\n}\n\nhtml[data-density='compact'] .sb-collapse-btn {\n  width: 30px;\n  height: 30px;\n}\n\nhtml[data-density='compact'] .sb-item,\nhtml[data-density='compact'] .sb-staff-toggle {\n  padding: 6px var(--space-sm);\n  font-size: var(--font-size-sm);\n}\n\nhtml[data-density='compact'] .sb-icon {\n  font-size: var(--font-size-base);\n}\n\nhtml[data-density='compact'] .sb-staff {\n  margin-top: var(--space-xs);\n  padding-top: var(--space-xs);\n}\n\n/* On large screens, comfortable mode can breathe a bit more. */\nhtml[data-density='comfortable'] .app-content {\n  padding: var(--space-lg) var(--space-xl);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
